// Use this HOC in state config with "component" property (instead of "template")
import { store } from "../../../../single-spa/store/store";
import TranslationProvider from "pro-features/components/WithTranslation/src/TranslationProvider";
import { i18nFilter } from "app/filters/i18nFilter";
import TrackProvider from "pro-features/components/WithTrack/src/TrackProvider";
import { allTrackers } from "app/services/track/track";
import { Provider } from "react-redux";

export const withAllContextHoc = (Component) => {
    return function (props) {
        return (
            <Provider store={store}>
                <TranslationProvider translate={i18nFilter()}>
                    <TrackProvider track={allTrackers.trackEvent.bind(allTrackers)}>
                        <Component {...props} />
                    </TrackProvider>
                </TranslationProvider>
            </Provider>
        );
    };
};
